/** @jsx $jsx */
import { $jsx } from 'framework7';
import { usadosFunciones } from "../js/usadosFunciones";
function framework7Component(props, _ref) {
  var $ = _ref.$,
    $f7 = _ref.$f7,
    $on = _ref.$on;
  $on('pageInit', function (event, page) {
    var usados = new usadosFunciones();
    var userID = localStorage.getItem('idUser');
    var vehiculoID = page.route.query.id_vehiculo;
    usados.listarElementosPericias($f7, vehiculoID);
    console.log('pageInit');
  });

  ///////////////////////
  $on('pageBeforeIn', function (event, page) {
    console.log('pageBeforeIn');
  });
  $on('pageAfterIn', function (event, page) {
    console.log('pageAfterIn');
  });
  $on('pageBeforeRemove', function (event, page) {
    console.log('pageBeforeRemove');
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="about">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner sliding">
        <div class="left">
          <a href="#" class="link back">
            <i class="icon icon-back"></i>
            <span class="if-not-md">Volver</span>
          </a>
        </div>
        <div class="title">PERITAJE</div>
      </div>
    </div>
    <!-- <div class="fab fab-extended fab-right-bottom color-green"> -->
      <!-- <a href="" id="get-camara">
        <i class="icon f7-icons if-not-md">camera_fill</i>
        <i class="icon material-icons md-only">camera_fill</i> -->
        <!-- <div class="fab-text popup-open" href="#" data-popup=".popup-about">Agregar</div> -->
        <!-- <div class="fab-text" href="#">Agregar</div> -->
      <!-- </a>
    </div> -->
    <!-- <div class="fab fab-extended fab-center-bottom color-blue">
      <a href="#" id="save-imagen">
        <i class="icon f7-icons if-not-md">cloud_upload_fill</i>
        <i class="icon material-icons md-only">cloud_upload_fill</i>
        <div class="fab-text">Guardar</div>
      </a>
    </div> -->
    <div class="page-content">
      <div class="block">
        
        
        <div class="list accordion-list">
          <ul id="listadoCheck">
          </ul>
        </div>

        
      </div>
    </div>
  </div>
  `
    }
    ;
}
framework7Component.id = '9616921436';
export default framework7Component;